import { Avatar, Grid, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import FileBase64 from 'react-file-base64';
import { useTranslation } from "react-i18next";
import cameraplus2 from '../../assets/AddPhotoIcon.svg'
import './phoneInput.css';

export default function ProfileUplod(props) { 
    const { t } = useTranslation();
    const [profile, setProfile] = React.useState(cameraplus2);
    const [file, setFile] = React.useState({});
    const [state, setState] = React.useState({
        profilePhoto: ''
    });
    const handleProfile = (file) => {
        if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/bmp') {
            let fileSize = file.size.split(' ')[0];
            let size = parseInt(fileSize);
            if (size <= 7168) {
                setFile(file);
                setState({
                    ...state,
                    profilePhoto: file.base64.split(',')[1],
                });
                props.onsetProfile(file.base64)
                setProfile(file.base64);
            } else {
                setFile(false);
                setProfile('');
                props.onsetProfile("Error")
                props.handalInvalidImg("Invalid")
            }
        } else {
            setFile('');
            setProfile('');
            props.onsetProfile("Error")
            props.handalInvalidImg("Invalid")
        }
    };

    return (
        <>
            <Grid conatiner display={'flex'} direction='column' justifyContent='center' alignItems='center'>
                <div style={{ borderStyle: 'dotted', borderRadius: '50%', padding: '5px', color: !file ? 'red' : '#D2D2D2' }}>
                    <Tooltip title={props.profilePhoto ? t('PROFILE_UPLOAD') : ''}>
                        <IconButton
                            variant='contained'
                            component='label'
                            style={{
                                position: 'relative',
                                width: '210px',
                                height: '210px',
                                font: 'normal normal normal 18px/24px Roboto',
                                letterSpacing: '0px'
                            }}
                            disabled={props.disabled}
                        >
                            {props.profilePhoto ?
                                <Avatar
                                    className='ImageContent'
                                    alt='' src={props.profilePhoto}
                                    style={{
                                        height: '200px',
                                        width: '200px',
                                        zIndex: '99',
                                        borderRadius: '50%'
                                    }}
                                /> :
                                <>
                                    <Avatar
                                        className='ImageContent'
                                        alt='' src={profile}
                                        style={{
                                            height: '100%',
                                            width: '100%',
                                            borderRadius: '50%',
                                            backgroundColor: '#F4F6F8'
                                        }}
                                        sx={[
                                            () => ({
                                                "& .MuiAvatar-img": {
                                                    width: '49px',
                                                    height: '42px',
                                                    textAlign: 'center',
                                                    objectFit: 'cover',
                                                    color: 'transparent',
                                                    textIndent: '10000px'
                                                },
                                            }),
                                        ]}
                                    />
                                    <div style={{ position: 'absolute', top: '68%', left: '30%', zIndex: '1', color: '#C3C5C7', justifyContent: 'center' }}>Upload Photo </div>
                                    <Grid style={{ display: 'none' }}>
                                        <FileBase64 multiple={false} onDone={(file) => handleProfile(file)} />
                                    </Grid>
                                </>
                            }
                            <Grid style={{ display: 'none' }}>
                                <FileBase64 multiple={false} onDone={(file) => handleProfile(file)} />
                            </Grid>
                        </IconButton>
                    </Tooltip>
                </div>
                <Grid direction='row' display='flex' alignItems='flex-end' style={{ color: '#C3C5C7', opacity: 1, fontSize: '12px', paddingTop: '34px', justifyContent: 'center' }}>
                    {!file ? 'Image size should be less than 7MB' : 'Allowed *.jpeg, *.jpg, *.png max size of 7 MB'}
                </Grid>
            </Grid >
        </>
    );
}

ProfileUplod.defaultProps = {
    disabled: false,
}